import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {//设置全局访问对象
    navbar: sessionStorage.getItem("sessionNavbar")?sessionStorage.getItem("sessionNavbar"):0
}

const getters = {//实时监听state值的最新变化
    changeNav(state){//承载变化的state.nanbar的值
        return state.navbar
    }

}

const mutations = {//commit 提交方法
    setNavbar(state,nav){//自定义改变state 初始值的方法,nav参数
        state.navbar = nav
    }
}

const actions = {
    getNavbar(context,nav){//自定义触发mutations里的函数方法，constext 与store具有相同方法跟属性
        sessionStorage.setItem("sessionNavbar", nav);
        context.commit('setNavbar',nav)
    }
}
/**
 * 在外部组件里进行全局执行actions里面方法的时候
 * 执行this.$store.dispatch('getNavbar')
 * 
 */

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});



export default store;


// WEBPACK FOOTER //
// ./src/store/index.js